import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import { JupiterTheme } from '../../theme/types';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    root: {
      ...theme.typography.body2,
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.error.main,
      color: '#fff',
      fontWeight: theme.typography.fontWeightMedium,
      display: 'flex',
      padding: '6px 16px',
    },
    icon: {
      marginRight: 12,
      padding: '7px 0',
      display: 'flex',
      fontSize: 22,
      opacity: 0.9,
    },
    message: {
      padding: '8px 0',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    typography: {
      fontWeight: theme.typography.fontWeightMedium,
      marginTop: -2,
    },
  })
);

/*
As of January 2020, there is an "Alert" component in @material-ui/lab that hasn't been
migrated to @material-ui/core yet. Hopefully that component can replace this one eventually.
*/

interface Props {
  children: any;
}

const ErrorAlert = ({ children }: Props) => {
  const classes = useStyles();
  return (
    <Paper role="alert" square elevation={0} className={classes.root}>
      <div className={classes.icon}>
        <ErrorOutlineIcon fontSize="inherit" />
      </div>
      <div className={classes.message}>
        <Typography gutterBottom component="div" className={classes.typography}>
          {children}
        </Typography>
      </div>
    </Paper>
  );
};

export default ErrorAlert;
